import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Tooltip } from "components/tooltip";
import React from "react";
import Skeleton from "react-loading-skeleton";
import InfoIcon from "../../../public/icons/info.svg";
export var CardRow = function(param) {
    var label = param.label, unit = param.unit, tooltipContent = param.tooltip, _showLabel = param.showLabel, showLabel = _showLabel === void 0 ? false : _showLabel, _center = param.center, center = _center === void 0 ? true : _center, isLoading = param.isLoading, children = param.children, className = param.className;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("text-sm flex md:flex-col", {
            "md:items-start": !center,
            "items-center": center,
            "md:text-center": center
        }, className),
        children: [
            !!label && /*#__PURE__*/ _jsxs("div", {
                className: classNames("flex-1 flex flex-row items-center text-default text-xs md:mb-2 md:mr-0 mr-2", {
                    "md:hidden": !showLabel
                }),
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        children: [
                            label,
                            !!unit && " (".concat(unit, ")")
                        ]
                    }),
                    !!tooltipContent && /*#__PURE__*/ _jsx(Tooltip, {
                        content: tooltipContent,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "ml-1 cursor-help",
                            children: /*#__PURE__*/ _jsx(InfoIcon, {})
                        })
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ _jsx(Skeleton, {
                className: "px-3 sm:h-5"
            }) : children,
            !!unit && /*#__PURE__*/ _jsx("div", {
                className: classNames("hidden text-xs mt-2", {
                    "md:block": !showLabel
                }),
                children: unit
            })
        ]
    });
};
